(function () {
  const trigger = document.querySelector('.HorizontalList__Item > a[href="#project-foundation"]');
  const mobileTrigger = document.querySelector('.Collapsible > a[href="#project-foundation"]');
  
  trigger && trigger.addEventListener('click', function(e) {
    e.preventDefault(); 
    const element = document.getElementById('project-foundation');
    const elementRect = element.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset - 180;
   
    setTimeout( () => {
      window.scrollTo({
        top: absoluteElementTop,
        behavior: 'smooth'
      });
    });
  });

  mobileTrigger && mobileTrigger.addEventListener('click', function(e) {
    e.preventDefault(); 
    const element = document.getElementById('project-foundation');
    const elementRect = element.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset - 80;

    setTimeout( () => {
      window.scrollTo({
        top: absoluteElementTop,
        behavior: 'smooth'
      });
      document.querySelector('.Drawer__Close').click();
    });
  });

  window.onload = function() {
    if (window.location.href.indexOf('project-foundation') > -1) {
      const element = document.getElementById('project-foundation');
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset - 180;
      const absoluteElementTopMobile = elementRect.top + window.pageYOffset - 80;
      const mediaQuery = window.matchMedia("(max-width: 767px)");

      setTimeout(() => {
        window.scrollTo({
          top: absoluteElementTop,
          behavior: 'smooth'
        });
      }, 100);

      if (mediaQuery.matches) {
        setTimeout(() => {
          window.scrollTo({
            top: absoluteElementTopMobile,
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  };
})();
